import Modal from '@/app/components/Modal';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

export default function AllWishlistModals({ individualItem, productData }) {
  const { commonModal } = useSelector((state) => state.wishlistModal);

  const [isOpenNotificationOnModal, setIsOpenNotificationOnModal] =
    useState(false);
  const handleCloseNotificationOnModal = (state) =>
    setIsOpenNotificationOnModal(state);

  return (
    <>
      {/* wishlist all item remove confirm-modal */}
      {/* <Modal
        type="wishlist-item-remove-confirm-modal"
        onView={isOpenWishlistItemRemoveConfirmModal}
        onClose={handleCloseWishlistItemRemoveConfirmModal}
      /> */}
      {/* you will be notified modal */}
      <Modal
        type="notification-on-modal"
        data="You will be notified once the product is in stock."
        onView={isOpenNotificationOnModal}
        onClose={handleCloseNotificationOnModal}
      />

      {/* wishlist item has been removed modal */}
      <Modal type="common-modal" data={commonModal?.data} onClose={() => {}} />

      {/* product add to wishlist modal */}
      <Modal type="wishlist-notification" />
    </>
  );
}
